/**
 * Modal xác nhận xóa tin BĐS — giữ snapshot property khi đang đóng.
 */
import { useEffect, useState } from 'react';
import { ButtonSpinner } from '../Common/ButtonSpinner';
import { AdminModal } from './AdminModal';
import { formatText, TEXT } from '../../shared/languages';

/**
 * Modal xác nhận xóa BĐS.
 * @param {Object} props
 * @param {Object|null} props.property
 * @param {boolean} [props.isOpen]
 * @param {boolean} [props.isDeleting]
 * @param {Function} props.onClose
 * @param {Function} props.onConfirm
 */
export const AdminPropertyDeleteModal = ({
  property,
  isOpen = Boolean(property),
  isDeleting = false,
  onClose,
  onConfirm,
}) => {
  const admin = TEXT.admin;
  const common = TEXT.common;
  const [displayProperty, setDisplayProperty] = useState(property);

  useEffect(() => {
    if (property) {
      setDisplayProperty(property);
    }
  }, [property]);

  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      panelClassName="admin-confirm-modal"
      role="alertdialog"
      ariaLabelledby="admin-property-delete-title"
      ariaDescribedby="admin-property-delete-message"
    >
      {displayProperty && (
        <>
          <div className="admin-confirm-modal-header">
            <h2 id="admin-property-delete-title">{admin.deleteDialogTitle}</h2>
          </div>

          <div className="admin-confirm-modal-body">
            <p id="admin-property-delete-message">
              {formatText(admin.deleteConfirm, { title: displayProperty.title })}
            </p>
            <p className="admin-confirm-modal-hint">{admin.deleteDialogHint}</p>
          </div>

          <div className="admin-confirm-modal-actions">
            <button type="button" className="button ghost" disabled={isDeleting} onClick={onClose}>
              {common.close}
            </button>
            <button
              type="button"
              className="button admin-confirm-modal-delete"
              disabled={isDeleting}
              onClick={onConfirm}
            >
              {isDeleting && <ButtonSpinner />}
              {isDeleting ? common.deleting : common.delete}
            </button>
          </div>
        </>
      )}
    </AdminModal>
  );
};
